import { Directive, Input, TemplateRef } from '@angular/core';

@Directive({
	selector: '[appTabContent]'
})
export class VerticalTabContentDirective {
	@Input('appTabContent') tabId: string = '';

	constructor(public templateRef: TemplateRef<unknown>) {}
}
